<template>
  <div>
    <div class="trending-area fix">
      <div class="container">
        <div class="trending-main">
          <div class="row">
            <div class="col-lg-3 d-xs-none" style="font-size: 12px!important;">
              <!-- Category -->
              <div class="category mb-30">
                <div class="category__title">
                  <h4><i class="fas fa-list-ul"></i>Danh mục tài sản</h4>
                </div>
                <div class="category__list">
                  <a class="category__item" href="#">
                    QUYỀN SỬ DỤNG ĐẤT ĐỂ GIAO ĐẤT HOẶC CHO THUÊ ĐẤT
                  </a>
                  <a class="category__item" href="#">
                    TÀI SẢN LÀ NỢ XẤU VÀ TÀI SẢN BẢO ĐẢM TẠI TỔ CHỨC TÍN DỤNG
                  </a>
                  <a class="category__item" href="#">
                    TÀI SẢN THI HÀNH ÁN
                  </a>
                  <a class="category__item" href="#">
                    TÀI SẢN LÀ TANG VẬT, PHƯƠNG TIỆN VI PHẠM HÀNH CHÍNH HOẶC TÀI SẢN KÊ BIÊN
                  </a>
                  <a class="category__item" href="#">
                    TÀI SẢN NHÀ NƯỚC
                  </a>
                  <a class="category__item" href="#">
                    CÁC LOẠI TÀI SẢN KHÁC
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="carousel zippy-carousel transition">
                <div class="inner">
                  <carousel
                    :paginationPosition="'top-overlay'"
                    :per-page="1"
                    :autoplay="true"
                    :loop="true"
                    :autoplayTimeout="3000"
                  >
                    <slide>
                      <img style="width:100%;height: 100%;" src="@/assets/images/838b4325c8a132ff6bb0.jpg" />
                    </slide>
                    <slide>
                      <img style="width:100%;height: 100%;" src="@/assets/images/fdaf5a3571b28becd2a3.jpg" />
                    </slide>
                    <slide>
                      <img style="width:100%;height: 100%;" src="@/assets/images/sep.jpg" />
                    </slide>
                    <slide>
                      <img style="width:100%;height: 100%;" src="@/assets/images/thu truong B.jpg" />
                    </slide>
                  </carousel>
                </div>
              </div>
            </div>
            <!-- Riht content -->
            <div class="col-lg-3">
              <!-- Category -->
              <div class="support mb-30">
                <div class="support__title">
                  <h4>HỖ TRỢ:</h4>
                </div>
                <div class="support__list">
                  <a href="#"><i class="fas fa-headphones"></i> Hotline: 0243.7622619</a>
                  <a href="#">Email: daugiatructuyen.nalaf@gmail.com</a>
                </div>
                <div class="support__title">
                  <h4>HƯỚNG DẪN:</h4>
                </div>
                <div class="support__list">
                  <a href="/files/huong_dan_su_dung.pdf" target="_blank">Hướng dẫn tham gia đấu giá</a>
                  <a href="/files/nguoi_co_tai_san.pdf" target="_blank">Hướng dẫn người có tài sản</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="whats-news-area pt-50 pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <!--Nav Button  -->
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active"
                        id="nav-home-tab"
                        data-toggle="tab"
                        href="#nav-home"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                        >TIN TỨC NỔI BẬT VỀ ĐẤU GIÁ TRỰC TUYẾN</a
                      >
                    </div>
                  </nav>
                  <!--End Nav Button  -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- card one -->
                  <div
                    style="    line-height: 23px;"
                    class="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div class="whats-news-caption">
                      <div class="row">
                        <!-- <div class="col-lg-6 col-md-6 col-sm-12">
                                              <a href="/files/danh_sach_khong_du_dieu_kien_31.pdf" target="_blank" style="color: red;">
                                                  - Danh sách người không đủ điều kiện tham gia đấu giá tài sản là Quyền sử dụng đất...
                                              </a>
                                          </div> -->
                        <!-- <div class="col-lg-6 col-md-6 col-sm-12"><a href="https://phapluatxahoi.vn/dau-gia-tai-san-truc-tuyen-la-xu-the-tat-yeu-195854.html">- Đấu giá tài sản trực tuyến là xu thế tất yếu</a></div>
                                          <div class="col-lg-6 col-md-6 col-sm-12"><a href="https://baodauthau.vn/dau-gia/chia-se-ha-tang-trien-khai-dau-gia-truc-tuyen-130487.html">- Chia sẻ hạ tầng triển khai đấu giá trực tuyến</a></div>
                                          <div class="col-lg-6 col-md-6 col-sm-12"><a href="https://baophapluat.vn/tu-phap/doanh-nghiep-muon-lan-toa-hinh-thuc-dau-gia-truc-tuyen-521320.html">- Doanh nghiệp muốn lan tỏa hình thức đấu giá trực tuyến</a></div>
                                          <div class="col-lg-6 col-md-6 col-sm-12"><a href="https://congly.vn/xa-hoi/doi-song/dau-gia-tai-san-truc-tuyen-ngan-chan-tinh-trang-thieu-minh-bach-thong-tin-345896.html">- Đấu giá tài sản trực tuyến ngăn chặn tình trạng thiếu minh bạch thông tin</a></div>
                                          <div class="col-lg-6 col-md-6 col-sm-12"><a v-on:click="$router.push('/new/5')">- Điều kiện thực hiện đấu giá trực tuyến</a></div>
                                          
                                          <div class="col-lg-6 col-md-6 col-sm-12"><a href="http://dangcongsan.vn/day-manh-cai-cach-tu-phap-va-hoat-dong-tu-phap/tin-tuc/lan-toa-hinh-thuc-dau-gia-truc-tuyen-556283.html">- Lan tỏa hình thức đấu giá trực tuyến</a></div>
                                          <div class="col-lg-6 col-md-6 col-sm-12"><a v-on:click="$router.push('/new/1')">- Tính ưu việt nổi bật của hình thức đấu giá trực tuyến</a></div>
                                          <div class="col-lg-6 col-md-6 col-sm-12"><a v-on:click="$router.push('/new/2')"> - Nguyên tắc đấu giá trực tuyến </a></div>
                                          <div class="col-lg-6 col-md-6 col-sm-12"><a v-on:click="$router.push('/new/3')"> - Trình tự thực hiện cuộc đấu giá bằng hình thức đấu giá trực tuyến</a></div>
                                          <div class="col-lg-6 col-md-6 col-sm-12"><a v-on:click="$router.push('/new/4')"> - Bảo vệ quyền của người trúng đấu giá </a></div>
                                           -->
                        <div v-for="i in news" :key="i.Id" class="col-lg-6 col-md-6 col-sm-12">
                          <a v-on:click="$router.push('/news/' + i.Id)" v-if="i.LoaiNoiDung == 0" target="_blank">
                            - {{ i.TrichDan }}.
                          </a>
                          <a v-else-if="i.LoaiNoiDung == 1" :href="i.DuongDan" target="_blank"> - {{ i.TrichDan }}. </a>
                          <a v-else-if="i.LoaiNoiDung == 2" :href="i.File" target="_blank"> - {{ i.TrichDan }}. </a>
                        </div>
                      </div>
                      <div class="row">
                        <!-- <div class="col-lg-4 col-md-4" v-for="i in list_auction_doing"  v-on:click="$router.push('/product/auction/'+i.PhienDauGia.Id)">
                                              <div class="single-what-news mb-70">
                                                  <div class="what-img">
                                                      <img :src="i.DinhKem.length>0? i.DinhKem[0].LinkDownload : ''" alt="">
                                                  </div>
                                                  <div class="what-cap">
                                                      <h4><a class="ellipsis">{{i.PhienDauGia.TenKeHoach}}</a></h4>
                                                  </div> 
                                              </div>
                                          </div> -->
                      </div>
                    </div>
                  </div>
                  <!-- Card two -->
                  <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="whats-news-caption">
                      <div class="row"></div>
                    </div>
                  </div>
                  <!-- Card three -->
                  <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                    <div class="whats-news-caption">
                      <div class="row"></div>
                    </div>
                  </div>
                </div>
                <div data-v-22ba47ca="" class="inner-bottom">&nbsp;</div>
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="whats-news-area pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <!--Nav Button  -->
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active"
                        id="nav-home-tab"
                        data-toggle="tab"
                        href="#nav-home"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                        >CUỘC ĐẤU GIÁ</a
                      >
                    </div>
                  </nav>
                  <!--End Nav Button  -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- card one -->
                  <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="whats-news-caption">
                      <div class="row">
                        <div
                          style="cursor: pointer;"
                          class="col-lg-4 col-md-4"
                          v-for="i in list_auction_do"
                          v-on:click="$router.push('/product/detail/' + i.PhienDauGia.Id)"
                        >
                          <div class="single-what-news mb-70">
                            <div class="what-img">
                              <!-- <image-avata :id="i.Id" :src="i.DinhKem.length>0? i.DinhKem[0].LinkDownload : ''"></image-avata> -->
                              <img :src="i.DinhKem.length > 0 ? i.DinhKem[0].LinkDownload : ''" alt="" />
                            </div>
                            <div class="what-cap">
                              <h4 v-if="i.Id == 201">
                                <a href="#" class="ellipsis"
                                  >Công ty Đấu giá Hợp danh Tân Đại Phát mời {{ i.PhienDauGia.TenKeHoach }}</a
                                >
                              </h4>
                              <h4 v-else>
                                <a href="#" class="ellipsis">{{ i.PhienDauGia.TenKeHoach }}</a>
                              </h4>
                            </div>
                            <div class="what-info">
                              <div class="icon">
                                <img src="@/assets/images/bua.svg" alt="" class="icon-bua" />
                              </div>
                              <div class="text">
                                <span
                                  >Giá khởi điểm:<strong
                                    >{{ i.GiaKhoiDiem.toLocaleString("da-DK") }} {{ i.PhienDauGia.DonViTinh }}</strong
                                  ></span
                                >
                                <span
                                  >Bước Giá:<strong
                                    >{{ i.BuocGia.toLocaleString("da-DK") }} {{ i.PhienDauGia.DonViTinh }}</strong
                                  ></span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Card two -->
                  <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="whats-news-caption">
                      <div class="row"></div>
                    </div>
                  </div>
                  <!-- Card three -->
                  <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                    <div class="whats-news-caption">
                      <div class="row"></div>
                    </div>
                  </div>
                </div>
                <!-- <div class="inner-bottom">&nbsp;</div> -->
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="whats-news-area pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <!--Nav Button  -->
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active"
                        id="nav-home-tab"
                        data-toggle="tab"
                        href="#nav-home"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                        >THÔNG TIN MỜI THAM GIA ĐẤU GIÁ – TÀI SẢN ĐẤU GIÁ</a
                      >
                    </div>
                  </nav>
                  <!--End Nav Button  -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- card one -->
                  <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="whats-news-caption">
                      <div class="row">
                        <div v-for="i in noti" :key="i.id" class="col-lg-6 col-md-6 col-sm-12">
                          <div class="row mb-10">
                            <div class="col-3">
                              <img v-if="i.Id != 17" style="width: 100%;" src="@/assets/images/thongbao.jpg" alt="" />
                              <img v-else style="width: 100%;" src="/taisan/201/1.jpg" alt="" />
                            </div>
                            <div class="col-9" style="margin: auto;">
                              <a v-on:click="$router.push('/news/' + i.Id)" v-if="i.LoaiNoiDung == 0" target="_blank">
                                - {{ i.TrichDan }}.
                              </a>
                              <a v-else-if="i.LoaiNoiDung == 1" :href="i.DuongDan" target="_blank">
                                - {{ i.TrichDan }}.
                              </a>
                              <a v-else-if="i.LoaiNoiDung == 2" :href="i.File" target="_blank"> - {{ i.TrichDan }}. </a>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-lg-6 col-md-6 col-sm-12">
                                              <div class="row mb-10" >
                                                  <div class="col-3">
                                                  <img style="width: 100%;" src="@/assets/images/thongbao.jpg" alt=""></div>
                                                  <div class="col-9" style="margin: auto;">
                                                      <a href="/files/khu-dat-dg1.pdf" target="_blank" >
                                                          - TB mời tham gia đấu giá quyền sử dụng đất tại khu đất...
                                                      </a>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12">
                                              <div class="row mb-10" >
                                                  <div class="col-3">
                                                  <img style="width: 100%;" src="@/assets/images/thongbao.jpg" alt=""></div>
                                                  <div class="col-9" style="margin: auto;">
                                                      <a href="/files/o-dat-cl.pdf" target="_blank" >
                                                          - TB mời tham gia ĐG quyền sử dụng thửa đất các ô đất trong khu Cl-02, CL-03, huyện Đông Anh...
                                                      </a>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12">
                                              <div class="row mb-10" >
                                                  <div class="col-3">
                                                  <img style="width: 100%;" src="@/assets/images/thongbao.jpg" alt=""></div>
                                                  <div class="col-9" style="margin: auto;">
                                                      <a href="/files/dau-gia-hg.pdf" target="_blank" >
                                                          - TB mời tham gia ĐG quyền sử dụng đất ở vị trí tại thôn Nhân Hiền, xã Hiền Giang, huyện Thường Tín...
                                                      </a>
                                                  </div>
                                              </div>
                                          </div> -->
                        <!-- <div class="col-lg-6 col-md-6 col-sm-12">
                                              <div class="row mb-10" >
                                                  <div class="col-3">
                                                  <img style="width: 100%;" src="@/assets/images/thongbao.jpg" alt=""></div>
                                                  <div class="col-9" style="margin: auto;">
                                                      <a v-on:click="$router.push('/invates/1')" >
                                                          - Thông báo về việc chuẩn bị tổ chức đấu giá căn hộ trung cư...
                                                      </a>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12">
                                              <div class="row mb-10" >
                                                  <div class="col-3">
                                                  <img style="width: 100%;" src="@/assets/images/thongbao.jpg" alt=""></div>
                                                  <div class="col-9" style="margin: auto;">
                                                      <a v-on:click="$router.push('/invates/2')" >- Thông báo về việc chuẩn bị tổ chức đấu giá quyền sử dụng đất...</a>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="inner-bottom">&nbsp;</div>
                                          <h1 style="width: 100%; margin-bottom: 20px"></h1> -->
                        <!-- <div style="cursor: pointer;" class="col-lg-6 col-md-6" v-for="i in list_auction_do" v-on:click="$router.push('/product/detail/'+i.PhienDauGia.Id)">
                                              <div class="row">
                                                  <div class="col-sm-6">
                                                      <div class="single-what-news">
                                                          <div class="what-img">
                                                          <image-avata :id="i.Id" :src="i.DinhKem.length>0? i.DinhKem[0].LinkDownload : ''"></image-avata>
                                                          <img :src="i.DinhKem.length>0? i.DinhKem[0].LinkDownload : ''"  alt="">
                                                      </div>
                                                  </div>
                                                  </div>
                                                  <div class="col-sm-6">
                                                      <div class="single-what-news">
                                                          <div class="what-cap">
                                                              <h4><a href="#" class="ellipsis">{{i.PhienDauGia.TenKeHoach}}</a></h4>
                                                          </div>
                                                          <div class="what-info">
                                                              <div class="text">
                                                                  <span>Giá khởi điểm:<strong>{{i.GiaKhoiDiem.toLocaleString('da-DK')}} {{i.PhienDauGia.DonViTinh}}</strong></span>
                                                                  <span>Bước Giá:<strong>{{i.BuocGia.toLocaleString('da-DK')}} {{i.PhienDauGia.DonViTinh}}</strong></span>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div> -->
                      </div>
                    </div>
                  </div>

                  <!-- Card two -->
                  <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="whats-news-caption">
                      <div class="row"></div>
                    </div>
                  </div>
                  <!-- Card three -->
                  <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                    <div class="whats-news-caption">
                      <div class="row"></div>
                    </div>
                  </div>
                </div>
                <!-- <div class="inner-bottom">&nbsp;</div> -->
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="whats-news-area pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <!--Nav Button  -->
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active"
                        id="nav-profile-tab"
                        data-toggle="tab"
                        href="#nav-profile"
                        role="tab"
                        aria-controls="nav-profile"
                        aria-selected="false"
                        >KIẾN THỨC PHÁP LUẬT</a
                      >
                    </div>
                  </nav>
                  <!--End Nav Button  -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- card one -->
                  <div
                    style="    line-height: 23px;"
                    class="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div class="whats-news-caption">
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <a target="_blank" href="http://vbpl.vn/botuphap/Pages/vbpq-van-ban-goc.aspx?ItemID=121748"
                              >- Luật đấu giá 2016</a
                            >
                          </div>
                          <div>
                            <a
                              target="_blank"
                              href="http://vbpl.vn/botuphap/Pages/vbpq-toanvan.aspx?ItemID=121741&Keyword=8"
                              >- Nghị định 62/2017/NĐ-CP</a
                            >
                          </div>
                          <div>
                            <a
                              target="_blank"
                              href="http://vbpl.vn/botuphap/Pages/vbpq-toanvan.aspx?ItemID=122824&Keyword="
                              >- Thông tư 06/2017/TT-BTP</a
                            >
                          </div>
                          <div>
                            <a
                              target="_blank"
                              href="http://vbpl.vn/botuphap/Pages/vbpq-toanvan.aspx?ItemID=17067&Keyword="
                              >- Luật giao địch điện tử</a
                            >
                          </div>
                          <div>
                            <a target="_blank" href="http://vbpl.vn/TW/Pages/vbpq-toanvan.aspx?ItemID=15066"
                              >- Luật công nghệ thông tin</a
                            >
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <a target="_blank" href="http://vbpl.vn/botuphap/Pages/vbpq-van-ban-goc.aspx?ItemID=30470"
                              >- Nghị định 52/2013/NĐ-CP</a
                            >
                          </div>
                          <div>
                            <a target="_blank" href="http://vbpl.vn/TW/Pages/vbpq-van-ban-goc.aspx?ItemID=105747"
                              >- Thông tư 59/2015/TT-BCT</a
                            >
                          </div>
                          <div>
                            <a
                              target="_blank"
                              href="http://vbpl.vn/bocongthuong/Pages/vbpq-van-ban-goc.aspx?ItemID=46686"
                              >- Thông tư 12/2013/TT-BCT</a
                            >
                          </div>
                          <div>
                            <a target="_blank" href="http://vbpl.vn/TW/Pages/vbpq-van-ban-goc.aspx?ItemID=44378"
                              >- Thông tư 47/2014/TT-BCT</a
                            >
                          </div>
                          <div>
                            <a
                              target="_blank"
                              href="http://vbpl.vn/bocongthuong/Pages/vbpq-toanvan.aspx?ItemID=130669&Keyword="
                              >- Thông tư 21/2018/TT-BCT</a
                            >
                          </div>
                        </div>
                      </div>
                      <!-- <div class="row">
                                          <div class="col-lg-4 col-md-4" v-for="i in list_auction_done" v-on:click="$router.push('/product/detail/'+i.PhienDauGia.Id)">
                                              <div class="single-what-news mb-70">
                                                  <div class="what-img">
                                                      <img :src="i.DinhKem.length>0? i.DinhKem[0].LinkDownload : ''" alt="">
                                                  </div>
                                                  <div class="what-cap">
                                                      <h4><a class="ellipsis">{{i.PhienDauGia.TenKeHoach}}</a></h4>
                                                  </div> 
                                              </div>
                                          </div>
                                      </div> -->
                    </div>
                  </div>
                  <!-- Card two -->
                  <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="whats-news-caption">
                      <div class="row"></div>
                    </div>
                  </div>
                  <!-- Card three -->
                  <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                    <div class="whats-news-caption">
                      <div class="row"></div>
                    </div>
                  </div>
                </div>
                <div data-v-22ba47ca="" class="inner-bottom">&nbsp;</div>
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style="display: none;" class="whats-news-area pt-50 pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <!--Nav Button  -->
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active"
                        id="nav-4-tab"
                        data-toggle="tab"
                        href="#nav-4"
                        role="tab"
                        aria-controls="nav-4"
                        aria-selected="true"
                        >Quy định pháp luật đấu giá
                      </a>
                    </div>
                  </nav>
                  <!--End Nav Button  -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- card one -->
                  <div class="tab-pane fade show active" id="nav-4" role="tabpanel" aria-labelledby="nav-4-tab">
                    <div class="row">
                      <div class="col-12">
                        <div class="home-news">
                          <a
                            href="http://vbpl.vn/botuphap/Pages/vbpq-toanvan.aspx?ItemID=122824&Keyword="
                            target="_blank"
                            >Thông tư 06/2017/TT-BTP</a
                          >
                          <a
                            href="http://vbpl.vn/botuphap/Pages/vbpq-toanvan.aspx?ItemID=17067&Keyword="
                            target="_blank"
                            >Luật giao địch điện tử</a
                          >
                          <a href="http://vbpl.vn/TW/Pages/vbpq-toanvan.aspx?ItemID=15066" target="_blank"
                            >Luật công nghệ thông tin</a
                          >
                          <a href="http://vbpl.vn/botuphap/Pages/vbpq-van-ban-goc.aspx?ItemID=30470" target="_blank"
                            >Nghị định 52/2013/NĐ-CP</a
                          >
                          <a href="http://vbpl.vn/TW/Pages/vbpq-van-ban-goc.aspx?ItemID=105747" target="_blank"
                            >Thông tư 59/2015/TT-BCT</a
                          >
                          <a href="http://vbpl.vn/bocongthuong/Pages/vbpq-van-ban-goc.aspx?ItemID=46686" target="_blank"
                            >Thông tư 12/2013/TT-BCT</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style="display: none;" class="whats-news-area pt-50 pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <!--Nav Button  -->
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active"
                        id="nav-4-tab"
                        data-toggle="tab"
                        href="#nav-4"
                        role="tab"
                        aria-controls="nav-4"
                        aria-selected="true"
                        >Thông báo đấu giá
                      </a>
                    </div>
                  </nav>
                  <!--End Nav Button  -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- Card two -->
                  <div class="tab-pane fade show active" id="nav-5" role="tabpanel" aria-labelledby="nav-5-tab">
                    <div class="row">
                      <div class="col-12">
                        <div class="home-news">
                          <a href="#">Thông báo đấu giá tài sản Ô tô</a>
                          <a href="#">Thông báo đấu giá tài sản Đất</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style="display: none;" class="whats-news-area pt-50 pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <!--Nav Button  -->
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active"
                        id="nav-4-tab"
                        data-toggle="tab"
                        href="#nav-4"
                        role="tab"
                        aria-controls="nav-4"
                        aria-selected="true"
                        >Thủ tục sau đấu giá</a
                      >
                    </div>
                  </nav>
                  <!--End Nav Button  -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- Card three -->
                  <div class="tab-pane fade show active" id="nav-6" role="tabpanel" aria-labelledby="nav-6-tab">
                    <div class="row">
                      <div class="col-lg-3 col-md-3 col-xs-12">
                        <div class="home-card">
                          <a href="#" alt="">
                            <img src="@/assets/images/kq.png" alt="" />
                            <span class="home-card__link">
                              Kết quả đấu giá
                            </span>
                          </a>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-3 col-xs-12">
                        <div class="home-card">
                          <a href="#" alt="">
                            <img src="@/assets/images/hd.jpg" alt="" />
                            <span class="home-card__link">
                              Hợp đồng mua bán tài sản
                            </span>
                          </a>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-3 col-xs-12">
                        <div class="home-card">
                          <a href="#" alt="">
                            <img src="@/assets/images/nh.jpg" alt="" />
                            <span class="home-card__link">
                              Bàn giao tài sản
                            </span>
                          </a>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-3 col-xs-12">
                        <div class="home-card">
                          <a href="#" alt="">
                            <img src="@/assets/images/ship.jpg" alt="" />
                            <span class="home-card__link">
                              Hỗ trợ giao hàng
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ImageAvata from "@/components/ImageAvata";
import mixin from "@/mixins/mixin.js";
import { mapGetters } from "vuex";
import User from "@/common/api/user";
import { saveToken, saveInfo } from "@/common/jwt";
import { LOGIN, SET_AUTH } from "@/store/actions.type";
import { Carousel, Slide } from "vue-carousel";
import Auction from "@/common/api/auction";
import News from "@/common/api/news";
import CONFIG from "@/common/config";
export default {
  name: "Dashboard",
  mixins: [mixin],
  components: { Carousel, Slide, ImageAvata },
  data() {
    return {
      messLogin: "",
      username: "",
      password: "",
      tab: 1,
      news: [],
      noti: [],
      list_auction_done: [],
      list_auction_do: [],
      list_auction_doing: [],
      list_type_auction: {
        do: CONFIG.ID_AUCTION_DO,
        doing: CONFIG.ID_AUCTION_DOING,
        done: CONFIG.ID_AUCTION_DONE
      },
      type_auction: CONFIG.ID_AUCTION_DOING
    };
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated"])
  },
  created() {
    this.getListAuctionDoing();
    this.getListAuctionDo();
    this.getListAuctionDone();
    this.getNews();
  },
  methods: {
    getNews() {
      News.getList().then(({ data }) => {
        for (var i = 0; i < data.Data.length; i++) {
          if (data.Data[i].LoaiTinTuc == 1) {
            this.noti.push(data.Data[i]);
          } else {
            this.news.push(data.Data[i]);
          }
        }
      });
    },
    goProfile() {
      this.$router.push("/profile");
    },
    goRegister() {
      this.$router.push("/register");
    },
    seeDetail(id) {
      this.$router.push("/product/detail/" + id);
    },
    seeAuction(id) {
      this.$router.push("/product/auction/" + id);
    },
    getListAuctionDoing() {
      Auction.getList(CONFIG.ID_AUCTION_DOING).then(({ data }) => {
        this.list_auction_doing = data.Data;
      });
    },
    getListAuctionDo() {
      Auction.getList(CONFIG.ID_AUCTION_DO).then(({ data }) => {
        this.list_auction_do = data.Data;
      });
    },
    getListAuctionDone() {
      Auction.getList(CONFIG.ID_AUCTION_DONE).then(({ data }) => {
        this.list_auction_done = data.Data;
      });
    }
  }
};
</script>

<style scoped>
.inner-bottom {
  width: 50%;
  height: 2px;
  margin: 0px auto;
  border-bottom: 1px solid #efefef;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue